// extracted by mini-css-extract-plugin
export default {"sectionContainer":"Animation_sectionContainer__+d+vR"};